import apiClient from '@/lib/apiClient';
import { buildListParams, extractPaginatedData } from '@/shared/utils/queryUtils';
import type { ListParams, PaginatedData, City, CityFormData, Country, Region } from '@/shared/types';

const BASE = '/admin/cities';

export const cityApi = {
  list: async (params: ListParams): Promise<PaginatedData<City>> => {
    const queryParams = buildListParams(params);
    const res = await apiClient.get(BASE, { params: queryParams });
    return extractPaginatedData(res);
  },

  getById: async (id: string | number): Promise<City> => {
    const res = await apiClient.get(`${BASE}/${id}`);
    return res.data?.data;
  },

  create: async (data: CityFormData): Promise<City> => {
    const res = await apiClient.post(BASE, data);
    return res.data?.data;
  },

  update: async (id: string | number, data: CityFormData): Promise<City> => {
    const res = await apiClient.patch(`${BASE}/${id}`, data);
    return res.data?.data;
  },

  delete: async (id: string | number): Promise<void> => {
    const res = await apiClient.delete(`${BASE}/${id}`);
    return res.data;
  },

  listCountries: async (): Promise<Country[]> => {
    const res = await apiClient.get('/admin/countries/all');
    return res.data?.data;
  },

  listRegionsByCountry: async (countryId: number): Promise<Region[]> => {
    const res = await apiClient.get(`/admin/regions/by-country/${countryId}`);
    return res.data?.data;
  },
};
